import { parseForm } from './parseForm'
import { validateEmail } from './validateEmail'

export type FormErrors<T extends string = string> = Partial<Record<T, string>>
export type FormKey = 'item' | 'email'
export const FORM_KEYS: FormKey[] = ['item', 'email']

export function validateForm(
  elements: HTMLFormControlsCollection,
  names: FormKey[]
): FormErrors<FormKey> {
  const data = parseForm(elements, names)
  const errors: FormErrors<FormKey> = {}
  if (!data.item) errors.item = 'URL or ASIN is required.'
  if (!data.email) errors.email = 'Company Email is required.'
  if (!!data.email && !validateEmail(data.email))
    errors.email = 'Email must be a valid company email'

  return errors
}
